import { GetCompany } from "./ApiCalls/company/getCompany";
import { GetCompanies } from "./ApiCalls/company/getCompanies";
import { DisableCompany } from "./ApiCalls/company/disabledCompany";
import { PostCompany } from "./ApiCalls/company/postCompany";
import { PatchCompany } from "./ApiCalls/company/patchCompany";
import i18n from "i18next";
import { GetCompanyreduced } from "./ApiCalls/company/getCompanyReduced";

const authInfoString = localStorage.getItem("authInfo");
const authInfo = authInfoString ? JSON.parse(authInfoString) : {};
const environment = authInfo.environment;
const modifiedBy = authInfo.idUser;

export async function GetComapanyService(idCompany, t) {
  try {
    const companyResponse = await GetCompany(idCompany);


    let environmentEnabled = true;

    const todayPlus30Days = new Date().getTime() + 30 * 24 * 60 * 60 * 1000;

    if (
      !companyResponse.environment.enabled ||
      (!companyResponse.environment.subscription &&
        new Date(companyResponse.environment.expireDate) < todayPlus30Days)
    ) {
      environmentEnabled = false;
    }

    const companyData = {
      companyId: companyResponse.company.company1,
      nifCif: companyResponse.company.nifCif,
      name: companyResponse.company.name,
      publicLink: companyResponse.company.publicLink,
      privacyPolicy: companyResponse.company.privacyPolicy,
      imageName: companyResponse.file.name,
      imageData: companyResponse.file.fileData,
      imageMimeType: companyResponse.file.mimeType,
      enabled: companyResponse.company.enabled,
      environmentEnabled: environmentEnabled,
      responsibleId: companyResponse.responsible.user1,
      responsibleFullName: `${companyResponse.responsible.name} ${companyResponse.responsible.surname}`,
      responsibleFullNameNIF: `${companyResponse.responsible.name} ${companyResponse.responsible.surname} (${companyResponse.responsible.nif ? companyResponse.responsible.nif : ""})`,
      functionResponsibleId: companyResponse.functionResponsible.user1,
      // functionResponsibleFullName: companyResponse.functionResponsible.user1
      //   ? `${companyResponse.functionResponsible.name} ${companyResponse.functionResponsible.surname}`
      //   : t("getCompaniesService.notSet"),
      functionResponsibleFullNameNIF: `${companyResponse.functionResponsible.name} ${companyResponse.functionResponsible.surname} (${companyResponse.functionResponsible.nif ? companyResponse.functionResponsible.nif : ""})`,
      createdAt: companyResponse.company.createdAt,
      modifiedOn: companyResponse.company.modifiedOn,
      modifiedBy: companyResponse.company.modifiedBy,
      workplaces: companyResponse.workPlace ? companyResponse.workPlace
        .filter(workplace => workplace.workPlace.enabled)
        .map((workplace) => {
          return {
            workplaceId: workplace.workPlace.workPlace1,
            workplaceName: workplace.workPlace.name,
            responsibleWorkPlaceId: workplace.responsibleWorkPlace ? workplace.responsibleWorkPlace?.user1 : null,
            workplaceEnabled: workplace.workPlace.enabled,
          };
        }) : [],
      textCompanies: companyResponse.text ? companyResponse.text.map((textCompany) => {
        return {
          textCompanyId: textCompany.textCompany1,
          text: textCompany.text,
          language: textCompany.languageDto.name,
          enabled: textCompany.enabled
        }
      }) : []
    };

    return companyData;
  } catch (error) {
    // console.error("Error during login:", error);
    // Manejar el error
    throw error;
  }
}

export async function GetComapanyServiceReduced(idCompany, t) {
  try {
    const companyResponse = await GetCompanyreduced(idCompany);

    let environmentEnabled = true;

    const todayPlus30Days = new Date().getTime() + 30 * 24 * 60 * 60 * 1000;

    if (
      !companyResponse.environment.enabled ||
      (!companyResponse.environment.subscription &&
        new Date(companyResponse.environment.expireDate) < todayPlus30Days)
    ) {
      environmentEnabled = false;
    }

    const companyData = {
      companyId: companyResponse.company.company1,
      nifCif: companyResponse.company.nifCif,
      name: companyResponse.company.name,
      publicLink: companyResponse.company.publicLink,
      privacyPolicy: companyResponse.company.privacyPolicy,
      imageName: companyResponse.file.name,
      imageData: companyResponse.file.fileData,
      imageMimeType: companyResponse.file.mimeType,
      enabled: companyResponse.company.enabled,
      environmentEnabled: environmentEnabled,
      responsibleId: companyResponse.responsible,
      functionResponsibleId: companyResponse.functionsResponsible,
      // functionResponsibleFullName: companyResponse.functionResponsible.user1
      //   ? `${companyResponse.functionResponsible.name} ${companyResponse.functionResponsible.surname}`
      //   : t("getCompaniesService.notSet"),
      createdAt: companyResponse.company.createdAt,
      modifiedOn: companyResponse.company.modifiedOn,
      modifiedBy: companyResponse.company.modifiedBy,
      workplaces: companyResponse.workPlace ? companyResponse.workPlace
        .filter(workplace => workplace.enabled)
        .map((workplace) => {
          return {
            workplaceId: workplace.workPlace1,
            workplaceName: workplace.name,
            workplaceEnabled: workplace.enabled,
          };
        }) : [],
      textCompanies: companyResponse.text ? companyResponse.text.map((textCompany) => {
        return {
          textCompanyId: textCompany.textCompany1,
          text: textCompany.text,
          language: textCompany.languageDto.name,
          enabled: textCompany.enabled
        }
      }) : []
    };

    return companyData;
  } catch (error) {
    // console.error("Error during login:", error);
    // Manejar el error
    throw error;
  }
}

export async function GetCompaniesService(t) {

  try {
    const data = await GetCompanies(environment);

    const companyData = data.map((companyData) => (
      {
        company: companyData.company.company1,
        nifCif: companyData.company.nifCif,
        name: companyData.company.name,
        publicLink: companyData.company.publicLink,
        // image: companyData.file.file1,
        // mimeType: companyData.file.mimeType,
        // imageName: companyData.file.name,
        // imageData: companyData.file.fileData,
        environment: companyData.company.environment,
        privacyPolicy: companyData.company.privacyPolicy,
        responsibleId: companyData.responsible.user1,
        responsibleFullName: `${companyData.responsible.name} ${companyData.responsible.surname}`,
        responsibleFullNameNIF: `${companyData.responsible.name} ${companyData.responsible.surname} (${companyData.responsible.nif})`,
        functionResponsibleId: companyData.functionResponsible.user1,
        functionResponsibleFullName: companyData.functionResponsible.user1
          ? `${companyData.functionResponsible.name} ${companyData.functionResponsible.surname}`
          : i18n.t("services:services.notAssigned"),
        functionResponsibleFullNameNIF: `${companyData.functionResponsible.name} ${companyData.functionResponsible.surname} (${companyData.functionResponsible.nif})`,
        enabled: companyData.company.enabled,
        createdAt: companyData.company.createdAt,
        modifiedOn: companyData.company.modifiedOn,
        modifiedBy: companyData.company.modifiedBy,
        // workplaces: companyData.workPlace ? companyData.workPlace.map((workplace) => {
        //   return {
        //     workplaceId: workplace.workPlace.workPlace1,
        //     workplaceName: workplace.workPlace.name,
        //     responsibleWorkPlaceId: workplace.responsibleWorkPlace ? workplace.responsibleWorkPlace?.user1 : null,
        //     responsibleWorkPlaceFullName: workplace.responsibleWorkPlace ? `${workplace.responsibleWorkPlace.name} ${workplace.responsibleWorkPlace.surname}` : "No asignado",
        //     responsibleWorkPlaceFullNameNIF: workplace.responsibleWorkPlace ? `${workplace.responsibleWorkPlace.name} ${workplace.responsibleWorkPlace.surname} (${workplace.responsibleWorkPlace.nif})` : "No asignado",
        //     workplaceEnabled: workplace.workPlace.enabled,
        //   };
        // }) : [],
        // textCompanies: companyData.text ? companyData.text.map((textCompany)=>{
        //   return {
        //     textCompanyId: textCompany.textCompany1,
        //     text: textCompany.text,
        //     language: textCompany.languageDto.name,
        //     enabled: textCompany.enabled
        //   }
        // }): []

      }));

    return companyData;
  } catch (error) {
    throw error;
  }
}

export async function PostCompanyService(comapny) {
  try {
    const comapanyData = await PostCompany(comapny, modifiedBy, environment);

    const companyResponse =
      "company" in comapanyData && "company1" in comapanyData.company
        ? {
          company: comapanyData.company.company1,
          nifCif: comapanyData.company.nifCif,
          name: comapanyData.company.name,
          publicLink: comapanyData.company.publicLink,
          image: comapanyData.file.file1,
          mimeType: comapanyData.file.mimeType,
          imageName: comapanyData.file.name,
          imageData: comapanyData.file.fileData,
          environment: comapanyData.company.environment,
          privacyPolicy: comapanyData.company.privacyPolicy,
          responsibleId: comapanyData.responsible.user1,
          responsibleFullName: `${comapanyData.responsible.name} ${comapanyData.responsible.surname}`,
          responsibleFullNameNIF: `${comapanyData.responsible.name} ${comapanyData.responsible.surname} (${comapanyData.responsible.nif})`,
          enabled: comapanyData.company.enabled,
          createdAt: comapanyData.company.createdAt,
          modifiedOn: comapanyData.company.modifiedOn,
          modifiedBy: comapanyData.company.modifiedBy,
        }
        : comapanyData.message;

    return companyResponse;
  } catch (error) {
    // console.error("Error during login:", error);
    // Manejar el error
    throw error;
  }
}

export async function PatchCompanyService(company, idCompany) {
  try {
    const companyData = await PatchCompany(company, modifiedBy, idCompany);

    const companyResponse =
      "company1" in companyData
        ? {
          company: companyData.company1,
        }
        : companyData.message;

    return companyResponse;
  } catch (error) {
    // console.error("Error during login:", error);
    // Manejar el error
    throw error;
  }
}

export async function DisabledCompanyService(company, idCompany) {
  try {
    const companyData = await DisableCompany(company, modifiedBy, idCompany);

    return companyData;
  } catch (error) {
    console.error("Error during disable company:", error);
    // Manejar el error
    throw error;
  }
}
